import { Link, useLocation } from "react-router-dom";
import { Home, Info, FileText, ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";

function Navigation() {
  const location = useLocation();
  
  const navItems = [
    { path: "/", icon: Home, label: "Rechner" },
    { path: "/info", icon: Info, label: "Über" },
    { path: "/impressum", icon: FileText, label: "Impressum" },
    { path: "/datenschutz", icon: ShieldCheck, label: "Datenschutz" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 mx-auto w-full max-w-md bg-white dark:bg-gray-900 shadow-lg border-t border-gray-100 dark:border-gray-800 flex justify-around py-3 px-2 rounded-t-xl z-40">
      {navItems.map(({path, icon: Icon, label}) => {
        const isActive = location.pathname === path;
        return (
          <Link 
            key={path} 
            to={path} 
            className="relative w-1/4 flex flex-col items-center"
          >
            <div className={`relative flex flex-col items-center transition-colors duration-200 ${
              isActive 
                ? "text-green-600" 
                : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
            }`}>
              {isActive && (
                <motion.div
                  layoutId="nav-indicator"
                  className="absolute -top-2 w-10 h-1 bg-green-600 rounded-full"
                  transition={{ 
                    type: "spring", 
                    duration: 0.5,
                    bounce: 0.2
                  }}
                />
              )}
              <Icon size={20} className="mb-1" />
              <span className="text-xs font-medium">{label}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default Navigation;